import { ArticleListMapType, DocArticleMetadata, DocArticleType } from 'routes/Docs/types'

import { getCleanPath, getParentPath, getTitleFromPath, sortArticleChildren } from './helpers'

export function makeDocsTree(articlesIndex: Map<string, DocArticleMetadata>) {
  const listMapValues = articlesIndex.values()
  for (const article of listMapValues) {
    // set parent and child relations
    if (article.parentRawPath) {
      setArticleParentChildRelationInListMap(article, articlesIndex)
    }
  }

  for (const article of listMapValues) {
    if (article.parentPath) {
      sortArticleChildren(article)
    }
  }
}

function setArticleParentChildRelationInListMap(article: DocArticleType, listMap: ArticleListMapType) {
  if (!article.parentPath || !article.parentRawPath) {
    return
  }

  // get parent node or create it if it doesn't exist
  const parentNode = listMap.get(article.parentPath) || createNodeInListMapByRawPath(listMap, article.parentRawPath)

  const parentNodeChildren = parentNode?.children ?? []
  /* `contains` method is not exist in `parentNodeChildren` ¯\_(ツ)_/¯ */
  if (parentNodeChildren.indexOf(article) === -1) {
    parentNode.children = [...parentNodeChildren, article]
  }
  article.parent = parentNode
}

function createNodeInListMapByRawPath(list: ArticleListMapType, rawPath: string): DocArticleType {
  const path = getCleanPath(rawPath)
  const parentPath = getParentPath(path)
  const parentRawPath = getParentPath(rawPath)

  const article: DocArticleMetadata = {
    Component: null,
    title: getTitleFromPath(path),
    path,
    rawPath,
    parentPath,
    parentRawPath,
  }

  list.set(path, article)

  // set parent-child relation if parent of created node exists
  if (parentRawPath) setArticleParentChildRelationInListMap(article, list)

  return article
}
